import Swiper from 'swiper';
import {Autoplay, EffectFade} from 'swiper/modules';
import 'swiper/swiper-bundle.css';

// init banner slider
const initBanner = () => {
    const swiper = new Swiper(".tt-banner .swiper-banner", {
        modules: [Autoplay, EffectFade],
        speed: 2000,
        spaceBetween: 30,
        effect: "fade",
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    });
};

export default initBanner;
